import isRetina from "is-retina";
import isTouchDevice from "is-touch-device";
import { isMobile } from "react-device-detect";

const colors = {
  default: "#000000",
  highlightColor: "#FFC124",
  white: "#FFFFFF",
};

const constants = {
  topBarHeight: 70,
  flowVerticalStripeW: 66,
  containerMaxW: 1920,
  narrowTopBarLanguageBarH: 60,
  isRetina: isRetina(),
  isTouch: isTouchDevice(),
  isMobile: isMobile,
  hoverProperty: () => {
    return isTouchDevice() ? "hover:active" : "hover";
  },
};

const breakpoints = {
  narrowTopBarLayout: 870,
  textScaleStopPoint: 600,
  twoColToOneColLayout: 1023,
  mediumOverlayNavPoint: 1400,
  narrowOverlayNavPoint: 740,
};

const theme = { ...colors, ...constants, ...breakpoints };

export default theme;



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/theme/theme.ts